import React, { useMemo } from "react";
import cn from "classnames";
import styles from "./style.module.scss";
import { isNonEmptyStr } from "../../utils/string";

interface Props {
  className?: string;
  logoUrl: string | null;
  companyName: string;
}

const CompanyLogo: React.FC<Props> = ({ className, logoUrl, companyName }) => {
  const imagePlaceholderShortName = useMemo(() => {
    return companyName
      .trim()
      .substr(0, 1)
      .toUpperCase();
  }, [companyName]);
  return (
    <div
      className={cn(className, styles.photo, {
        [styles.hasImage]: isNonEmptyStr(logoUrl),
      })}
      style={{
        backgroundImage: logoUrl ? `url(${logoUrl})` : "",
      }}
    >
      {!isNonEmptyStr(logoUrl) ? imagePlaceholderShortName : ""}
    </div>
  );
};

export default CompanyLogo;
